// extracted by mini-css-extract-plugin
module.exports = {"title":"t_p","cards":"t_G"};